import { Link } from 'react-router-dom';

export default function ArticleSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="lg:w-3/5 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%2C%20cream%20and%20beige%20neutral%20aesthetic%2C%20soft%20natural%20lighting%20from%20side%20window%2C%20clean%20Scandinavian%20desk%20setup%20with%20small%20plant%20and%20coffee%20cup%2C%20peaceful%20productive%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20gentle%20shadows&width=1200&height=800&seq=article-preview-01&orientation=landscape"
                alt="YOYBUY Spreadsheet руководство"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>

          <div className="lg:w-2/5 order-1 lg:order-2">
            <span className="inline-block text-xs uppercase tracking-[0.2em] text-foreground-400 font-medium mb-5">
              / О YOYBUY Sheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-semibold leading-tight mb-6">
              Что такое YOYBUY Spreadsheet и как он работает?
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-4">
              YOYBUY Spreadsheet — это инновационный инструмент для организации онлайн-покупок. С его помощью вы можете систематизировать заказы, отслеживать расходы и сравнивать товары из разных категорий. Платформа предлагает удобный интерфейс в формате электронной таблицы, который делает процесс шопинга прозрачным и эффективным.
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-8">
              В отличие от традиционных способов онлайн-шопинга, YOYBUY Spreadsheet позволяет хранить всю информацию о покупках в одном месте. Вы можете создавать списки желаний, отслеживать изменения цен и получать уведомления о скидках. Это идеальное решение для тех, кто ценит организованность и хочет экономить время и деньги.
            </p>

            <div className="flex items-center gap-6 mb-8">
              <div className="flex -space-x-3">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full border-2 border-background-100 bg-secondary-200 flex items-center justify-center"
                  >
                    <span className="text-[10px] text-secondary-700 font-semibold">
                      {String.fromCharCode(64 + i)}
                    </span>
                  </div>
                ))}
              </div>
              <span className="text-sm text-foreground-500">
                Более 10 000+ пользователей
              </span>
            </div>

            <Link
              to="/yoybuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-8 py-4 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Читать статью
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}